import { requireConfigValue } from "../../isomorphic-config";
import normalizeStore from "../../utils/normalizations/normalize-store";
export default function getStoreOperation({ commerce  }) {
    async function getStore({ variables: getStoreVariables = {} , config: userConfig  } = {}) {
        const { fieldsStore , include  } = getStoreVariables;
        const apiHost = requireConfigValue("apiHost");
        const params = new URLSearchParams();
        if (include) params.set("include", include);
        if (fieldsStore) params.set("fields[store]", fieldsStore);
        const qs = params.toString() ? `?${params.toString()}` : "";
        const url = `${apiHost}/api/v2/storefront/store${qs}`;
        try {
            const res = await fetch(url);
            if (!res.ok) {
                const body = await res.text().catch(()=>"");
                throw new Error(`getStore failed ${res.status} ${res.statusText} – ${url} – ${body.slice(0, 200)}`);
            }
            const json = await res.json();
            const store = normalizeStore(json);
            return {
                store
            };
        } catch (err) {
            console.error("[getStore] error:", err);
            throw err;
        }
    }
    return getStore;
};
